import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import usePost from "../services/usePost";
// import { showUserNotification } from "../utils/functions";
import { message } from "antd";

const VerifyAccount = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get("email");
  const code = queryParams.get("code");
  // const dispatch = useDispatch();
  const history = useHistory();

  const { callApi: verifyAccount, processSuccess: verifySuccess } = usePost({
    endpoint: `user/verifyAccount`,
  });

  useEffect(() => {
    const postData = {
      email,
      code,
    };

    verifyAccount(postData, "Account verified");
  }, [verifyAccount, email, code]);

  useEffect(() => {
    if (verifySuccess) {
      message.success("Account verified successfully");
      setTimeout(() => {
        history.push("/");
      }, 2000);
    } else {
      message.error("Account verification failed! Please try again");
    }
  }, [verifySuccess, history]);

  return <></>;
};

export default VerifyAccount;
